import { useEffect, useState } from "react";
import { IPanelEquipoModeloInsertar } from "./PanelEquipoModeloInsertar";
import { codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPostModeloAuxiliar, initialPostModeloAuxiliar } from "../../../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import EquipoModeloService from "../../../../../services/ListaVerificacion/EquipoModeloService";

export const UsePanelEquipoModeloInsertar = (props: IPanelEquipoModeloInsertar & { reloadCombo?: () => void }) => {
  const [requestAux, setRequestAux] = useState<IPostModeloAuxiliar>(
    initialPostModeloAuxiliar
  );

  const [disableForm, setDisableForm] = useState<boolean>(true);
  const [status, setStatus] = useState<codigosRespuesta>(0);
  const [mensaje, setMensaje] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const reset = () => {
    setMensaje("");
    setRequestAux(initialPostModeloAuxiliar);
    setStatus(0);
    props.onDismiss();
  };

  useEffect(() => {
    setDisableForm(!requestAux.equipoModeloId);
  }, [requestAux]);

  const postInsertarEquipoModelo = () => {
    setLoading(true);

    const requestFinal = {
      equipoModeloId: requestAux.equipoModeloId,
    };

    EquipoModeloService.PostCrearEquipoModelo(requestFinal)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.codigoMensaje === 1) {
            setMensaje(res.data.mensaje);

            setTimeout(() => {
              props.reloadCombo?.();
              reset();
            }, 1000);
          } else {
            setMensaje(res.data.mensaje);
            setStatus(500);
          }
        }
        setLoading(false);
      })
      .catch((e) => {
        setStatus(500);
        setLoading(false);
      });
  };

  return {
    requestAux,
    setRequestAux,
    postInsertarEquipoModelo,
    loading,
    disableForm,
    reset,
    mensaje,
    status,
  };
};